var CsComponentsModule = /** @class */ (function () {
    function CsComponentsModule() {
    }
    return CsComponentsModule;
}());
export { CsComponentsModule };
